import request from '../../utils/request';

const updateMe = async (options = {}) => request('self/me', { method: 'PUT', ...options});
const fetchRents = async (options = {}) => request('self/rent', { ...options});

export {
  fetchRents,
  updateMe,
}